import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '@/views/Home.vue';
import msal from '@/auth';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    component: Home
  }
];

const router = new VueRouter({
  routes,
  mode: 'history'
});

router.beforeEach((to, from, next) => {
  msal.handleRedirectCallback(err => {
    if (!err) {
      next();
    } else {
      console.warn(err);
    }
  });

  const account = msal.getAccount();

  if (account) {
    msal
      .ssoSilent({ loginHint: account.userName })
      .then(() => next())
      .catch(err => console.warn(err));
  } else {
    msal.loginRedirect({ scopes: ['User.ReadWrite'] });
  }
});

export default router;
